export const baseSelector = (state) => state.token;
export const tokenSelector = (state) => baseSelector(state).token;
export const tokenCustomerSelector = (state) => baseSelector(state).customer;
export const tokenReturnUrlSelector = (state) => baseSelector(state).returnUrl;

export default baseSelector;
